export default "data:text/plain;base64,MC4xLjM0"